<template>
    <div>
        <div class="button-container" id="approvalBtns">
            <button class="btn-round-green" :disabled="loadingSignOff" v-on:click="openSignOffForm('a');">APPROVE</button>
            <button class="btn-round-red" :disabled="loadingSignOff" v-on:click="openSignOffForm('d');">DENY</button>
            <button v-if="currentStepData.status != 'h' && submissionStatus != 'a'" class="btn-round-black" :disabled="loadingSignOff" v-on:click="openSignOffForm('h');">ON HOLD</button>
            <router-link v-if="editComponentName" :to="{ name: editComponentName, params: {ppId: ppId}}">
                <button class="btn-round-yellow" :disabled="loadingSignOff">EDIT</button>
            </router-link>
            <vue-loaders-ball-beat v-if="loadingSignOff" scale="1" color="black" style="padding-top: 25px;" />
        </div>
        <div v-if="displaySignOffNotes" id="signOffDiv">
            <form>
                <strong>{{ signOffAction }} NOTES:</strong><br>
                <textarea class="signOffNotes" v-model="signOffNotes" style="width:100%; height:8rem;"></textarea>
                <br>
                <button class="btn-round-green" type="submit" @click.prevent="emitSignOff">SUBMIT</button>
                <button class="btn-round-red" @click.prevent="hideSignOffForm();" id="cancelBtn">CANCEL</button>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            signOffAction: null,
            signOffNotes: null,
            signOffStatus: null,
        }
    },
    props: [
        'activityId', 
        'currentStepData', 
        'loadingSignOff', 
        'submissionStatus', 
        'ppId', 
        'displaySignOffNotes'
    ],
    computed: {
        editComponentName() {
            const componentMap = {
                1: 'PriceWorkflowSkuSelect',
                2: 'PriceWorkflowSkuSelect',
                3: null,
                4: 'PriceWorkflowSkuSelect',
                7: 'PriceWorkflowCustomDiscount'
            }

            return componentMap[this.activityId] || null;
        }
    },
    methods: {
        openSignOffForm(status) {
            if(status == "a") {
                this.signOffAction = "APPROVAL";
                this.signOffStatus = "a";
            } else if (status == "d") {
                this.signOffAction = "DENIAL";
                this.signOffStatus = "d";
            } else if (status == "h") {
                this.signOffAction = "ON HOLD";
                this.signOffStatus = "h";
            }

            // Workflow is approved and signoff is for entering into ERP. 
            // If on ERP step and status == "d", then we don't want to update this.signOffStatus
            if(status == "a" && this.submissionStatus == "a" && this.signOffStatus != "h") {
                this.signOffStatus = "e";
            }
            this.displaySignOffNotes = true;
        },
        hideSignOffForm() {
            this.signOffStatus = null;
            this.signOffNotes = null;
            this.displaySignOffNotes = false;
        },
        emitSignOff() {
            this.$emit('emit-sign-off', {
                signOffNotes: this.signOffNotes,
                signOffStatus: this.signOffStatus
            });

            this.signOffNotes = null;
        }
    },
}
</script>

<style scoped>
    .button-container {
        display: flex;
    }

    button {
        width: 100px;
    }
</style>